import React, { useState } from 'react'
import { Card, Row, Col, Button } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import { SPECTRUM_1, SPECTRUM_13, SPECTRUM_12, SPECTRUM_2, SPECTRUM_3, SPECTRUM_9, SPECTRUM_7, SPECTRUM_6, SPECTRUM_8, SPECTRUM_batch, SPECTRUM_star, Vector, } from '../../assets/images/index';
import './full_spectrum.css'
import ContactForm from '../contactus-popup/ContactForm';

const FullSpectrum = () => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const cardInfo = [
        {
            image: SPECTRUM_3,
            title: "Agentic AI",
            title2: "Software Development",
            description: "Build autonomous, goal-seeking agents that reason over data, take actions, and improve over time.",
        },
        {
            image: SPECTRUM_12,
            title: "AI Product Development",
            title2: "as a Services",
            description: "End-to-end product squads to design, ship, and scale agentic features and platforms faster.",
        },
        {
            image: SPECTRUM_2,
            title: "Cognitive Product",
            title2: "Design & Strategy",
            description: "UX that anticipates needs—experiences infused with adaptive intelligence and explainability.",
        },
        {
            image: SPECTRUM_13,
            title: "Cloud-Native AI",
            title2: "Infrastructure",
            description: "Secure, scalable MLOps stacks on AWS/Azure/GCP for real-time decisions and continuous learning.",
        },
        {
            image: SPECTRUM_1,
            title: "AI-Powered Mobile",
            title2: "Experiences",
            description: "Context-aware apps that personalize journeys on iOS and Android online and on-device",
        },
        {
            image: SPECTRUM_6,
            title: "Independent",
            title2: "Validation & Governance",
            description: "Model validation, drift monitoring, evaluation frameworks, and policy guardrails.",
        },
        {
            image: SPECTRUM_9,
            title: "Digital Transformation",
            title2: "to Autonomy",
            description: "Move from task automation to outcomes with multi-agent orchestration across workflows.",
        },
        {
            image: SPECTRUM_7,
            title: "AI Consulting",
            title2: "& Roadmapping",
            description: "Readiness assessments, business cases, and reference architectures aligned to KPIs.",
        },
        {
            image: SPECTRUM_8,
            title: "On-Demand",
            title2: "AI Agents Services",
            description: "Rapidly deploy function-specific agents for support, operations, finance, and IT.",
        },
    ];
    return (
        <div className='bg-section' id='services'>
        <Container>
           <h1 className='spectrum-title'>Our Expertise</h1>
           <p className='spectrum-sub-title'>Full-spectrum Agentic AI capability</p>
           <Card style={{ width: '100%' }} className='spectrum-card'>
           <img src={Vector} alt="vector" className='vector-img'/>
           <div className='batch-icon'>
              <img src={SPECTRUM_batch} alt="" className='batch-img' />
              <img src={SPECTRUM_star} alt="star-img" className="star-img"/>
           </div>
           <Row>
              {cardInfo.map((cardInfo, index) => {
              return (
              <Col sm={6} md={6} lg={4} key={index}>
              <Card style={{ border: 'none' }}>
              <Card.Img src={cardInfo.image} className='spect-img' />
              <Card.Body className='card-item'>
                 <Card.Title>{cardInfo.title} </Card.Title>
                 <Card.Title>{cardInfo.title2} </Card.Title>
                 <Card.Text>
                    {cardInfo.description}
                 </Card.Text>
              </Card.Body>
              </Card>
              </Col>
              )
              })}
           </Row>
           </Card>
           <div className='text-center mt-5'>
              <div className=" btn_shadow">
                 <div className='shadow_1'>
                 </div>
                 <div className='polygon_btn_cont'>
                    <Button className='polygon_btn' variant="outline-primary" onClick={handleShow}> Get Your Free Quote</Button>
                    <div className='polygon_shadow'></div>
                 </div>
              </div>
           </div>
        </Container>
        <ContactForm  show={show} onClose={handleClose}  onShow ={handleShow} />
     </div>
    )
}

export default FullSpectrum